import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { FormationSearchParams, FormationService } from '@app/models/formation';
import { ErrorService } from '@app/services/error.service';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-atom-formation-counter',
	templateUrl: './atom-formation-counter.component.html',
	styleUrls: ['./atom-formation-counter.component.less'],
})
export class AtomFormationCounterComponent implements OnInit {
	/** @type {Subject<void>} Observables unsubscriber */
	protected unsubscribe: Subject<void> = new Subject<void>();

	@Input() searchParams: FormationSearchParams;

	loading = true;
	count: number;

	constructor(
		private formationService: FormationService,
		private errorService: ErrorService
	) {}

	ngOnInit() {
		this.refresh();

		this.searchParams.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
			this.refresh();
		});
	}

	ngOnDestroy() {
		this.unsubscribe.next();
	}

	async refresh() {
		this.loading = true;
		if (this.searchParams) {
			const params = this.searchParams.toObjectSanitizedForCount();

			this.count = await this.formationService
				.count(params)
				.catch((err) => {
					this.errorService.handle(err);
					return null;
				});
		}
		this.loading = false;
	}
}
